export default "__VITE_ASSET__DQquVR7n__"